module.exports = __webpack_public_path__ + "static/media/firstFloorFront.74050e92.png";